export const palette = {
  cream: '#f0ebe0',
  midCream: '#e4ddd0',
  navy: '#1b2d6b',
  softNavy: '#2d4a9e',
  pink: '#e8337a',
  lightPink: '#fce4f0',
  white: '#ffffff',
  darkText: '#12142a',
  softText: '#4a4a6a',
};

